import { TableBody, TableCell, TableRow } from '../../../components/ui/table';
import { Inbox } from 'lucide-react';

/** Pulsing placeholder rows while a period loads. */
export function UploadTableSkeleton({ columns, rows = 5 }: { columns: number; rows?: number }) {
  return (
    <TableBody>
      {Array.from({ length: rows }).map((_, i) => (
        <TableRow key={i}>
          {Array.from({ length: columns }).map((__, j) => (
            <TableCell key={j}>
              <div className="h-4 w-full max-w-[9rem] animate-pulse rounded bg-muted" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
}

/** One full-width empty row with the given sentence. */
export function UploadTableEmpty({ columns, message }: { columns: number; message: string }) {
  return (
    <TableBody>
      <TableRow>
        <TableCell colSpan={columns} className="py-12 text-center">
          <Inbox className="mx-auto mb-2 h-8 w-8 text-muted-foreground" />
          <p className="text-sm text-muted-foreground">{message}</p>
        </TableCell>
      </TableRow>
    </TableBody>
  );
}
